import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faTimes,
  faChevronRight,
  faChevronDown,
  faBoxOpen,
  faClipboardList,
  faUsers,
  faShop,
  faPen,
  faEye,
  faBoxesStacked
} from '@fortawesome/free-solid-svg-icons';
import './ProviderMenu.css';

const ProviderMenu = ({ providerLogo, providerName, isOpen, toggleMenu, currentPage }) => {
  const menuRef = useRef();
  const [subMenuOpen, setSubMenuOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isOpen && menuRef.current && !menuRef.current.contains(e.target)) {
        toggleMenu(false);
      }
    };
    const handleScroll = (e) => {
      if (isOpen) e.preventDefault();
    };

    if (isOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('scroll', handleScroll, { passive: false });
    } else {
      document.body.style.overflow = '';
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isOpen, toggleMenu]);

  if (!isOpen) {
    return (
      <button className="menu-toggle-btn" onClick={() => toggleMenu(true)}>
        <FontAwesomeIcon icon={faBars} size="lg" />
      </button>
    );
  }

  return (
    <div className="provider-menu-overlay">
      <div ref={menuRef} className="provider-menu">
        <div className="menu-header">
          <img src={providerLogo} alt='perfil' />
          <div className="provider-info">
            <h3>{providerName}</h3>
            <p>Plan ultra</p>
          </div>
          <button onClick={() => toggleMenu(false)} className="close-btn">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <ul>
          {/* Desplegable principal */}
          <li>
            <button
              className="user-button dropdown-toggle"
              onClick={() => setSubMenuOpen(!subMenuOpen)}
            >
              <span className="icon-left"><FontAwesomeIcon icon={faBoxesStacked} id='icon-left' /></span>
              <span className="text">Mi inventario</span>
              <span className="icon-right">
                <FontAwesomeIcon id='icon-right' icon={subMenuOpen ? faChevronDown : faChevronRight} />
              </span>
            </button>

            <ul className={`submenu ${subMenuOpen ? 'open' : ''}`}>
              <li>
                <Link to="/my-products" className={currentPage === 'products' ? 'user-button active' : 'user-button'} onClick={() => toggleMenu(false)}>
                  <span className="icon-left subitem"><FontAwesomeIcon icon={faBoxOpen} /></span>
                  <span className="text">Mis productos</span>
                  <span className="icon-right"><FontAwesomeIcon icon={faChevronRight} /></span>
                </Link>
              </li>
              <li>
                <Link to="/edit-inventory" className={currentPage === 'edit-inventory' ? 'user-button active' : 'user-button'} onClick={() => toggleMenu(false)}>
                  <span className="icon-left subitem"><FontAwesomeIcon icon={faPen} /></span>
                  <span className="text">Editar inventario</span>
                  <span className="icon-right"><FontAwesomeIcon icon={faChevronRight} /></span>
                </Link>
              </li>
              <li>
                <Link to="/inventory-overview" className={currentPage === 'view-inventory' ? 'user-button active' : 'user-button'} onClick={() => toggleMenu(false)}>
                  <span className="icon-left subitem"><FontAwesomeIcon icon={faEye} /></span>
                  <span className="text">Ver inventario</span>
                  <span className="icon-right"><FontAwesomeIcon icon={faChevronRight} /></span>
                </Link>
              </li>
            </ul>
          </li>

          {/* Otros ítems */}
          <li>
            <Link to="/my-orders" className={currentPage === 'orders' ? 'user-button active' : 'user-button'} onClick={() => toggleMenu(false)}>
              <span className="icon-left"><FontAwesomeIcon icon={faClipboardList} /></span>
              <span className="text">Mis pedidos</span>
              <span className="icon-right"><FontAwesomeIcon icon={faChevronRight} /></span>
            </Link>
          </li>
          <li>
            <Link to="/my-customers" className={currentPage === 'customers' ? 'user-button active' : 'user-button'} onClick={() => toggleMenu(false)}>
              <span className="icon-left"><FontAwesomeIcon icon={faUsers} /></span>
              <span className="text">Mis clientes</span>
              <span className="icon-right"><FontAwesomeIcon icon={faChevronRight} /></span>
            </Link>
          </li>
          <li>
            <Link to="/my-store" className={currentPage === 'store' ? 'user-button active' : 'user-button'} onClick={() => toggleMenu(false)}>
              <span className="icon-left"><FontAwesomeIcon icon={faShop} /></span>
              <span className="text">Mi tienda</span>
              <span className="icon-right"><FontAwesomeIcon icon={faChevronRight} /></span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ProviderMenu;
